import React from 'react';
import UmlConnectorPointHandle from './UmlConnectorPointHandle.jsx';

/**
 * Renders the draggable waypoint handles for a single connector.
 * @param {object} props
 * @param {object} props.connector - connector data (uses connector.points)
 * @param {Function} props.onPointMoved - fn(pointId, x, y) — waypoint drag
 * @param {Function} props.onPointRemove - fn(connectorId, pointId) — waypoint delete
 * @param {Function} props.toWorldPoint - screen -> world coordinate conversion
 */
function UmlConnectorWaypoints({ connector, onPointMoved, onPointRemove, toWorldPoint }) {
    return (
        <>
            {connector.points.map(function renderPoint(point, index) {
                const size = 24;
                return (
                    <foreignObject
                        key={point.id}
                        x={point.x - size / 2}
                        y={point.y - size / 2}
                        width={size}
                        height={size}
                        data-connector-id={connector.id}
                        data-geo-label={`Waypoint ${index}`}
                        data-geo-x={point.x}
                        data-geo-y={point.y}
                    >
                        <UmlConnectorPointHandle
                            point={point}
                            onPointMoved={onPointMoved}
                            toWorldPoint={toWorldPoint}
                            onPointRemove={function removeThisPoint(pointId) {
                                onPointRemove?.(connector.id, pointId);
                            }}
                        />
                    </foreignObject>
                );
            })}
        </>
    );
}

export default UmlConnectorWaypoints;
